// extracted by mini-css-extract-plugin
export default {"logoHome":"Home_logoHome__bVSh8","home":"Home_home__dPAOF","topFlex":"Home_topFlex__5Itsp","credits":"Home_credits__PEwWT","warnButton":"Home_warnButton__6WAKq"};